export default __webpack_public_path__ + "static/e535ec76-8fc8-4985-94e6-9246a2c6b245-a0f5f0c69cb7539f4c627686dfe51101.woff2";